import { path, pathOr, last, lensPath, map, pipe, propOr, includes, filter, head, concat, pick, split, prop, } from 'ramda';

import * as RA from 'ramda-adjunct';
import { capitalizeFirst } from '../../../utility';

export const findStartDateOfCalendarDateId = (promoterDefault) => (calendarDateId) => {
  return path(['start_date'], pathOr([], ['promoters_calendar_date_ids'], promoterDefault).find(e => e.calendar_date_id == calendarDateId));
};



export const getPromoterDefaultDetails = (promoterDefault) => {
  const findStartDate = findStartDateOfCalendarDateId(promoterDefault)

  return Object.keys(promoterDefault)
    .filter(e => e.startsWith('booking_local_details_data'))
    .map(e => [e, last(e.split('booking_local_details_data_')), findStartDate(last(e.split('booking_local_details_data_')))])
    .map(([key, calendarDateId, date]) => ({
      startDate: date,
      calendarDateId: calendarDateId,
      localDetails: promoterDefault[key]
    }))
}

const resultsLens = lensPath(['data', 'content', 'results']);
const resultsView = RA.viewOr([], resultsLens);
const toOptionsMap = map(e => ({
  text: e.name,
  value: e.place_id
}));

export const hotelDataToOptions = pipe(
  resultsView,
  toOptionsMap
);

const resultLens = lensPath(['data', 'content', 'result']);
const resultView = RA.viewOr({}, resultLens);


const typeProp = propOr([], 'types');
const longNameProp = propOr('', 'long_name');
const includesLocality = includes('locality');

const filterLocality = filter(pipe(
  typeProp,
  includesLocality
));

// https://maps.googleapis.com/maps/api/place/photo?maxwidth=210&sensor=true&photoreference=&key=

const photoLens = lensPath(['data', 'content', 'result', 'photos', 0, 'photo_reference']);
const photoReferenceView = RA.viewOr('', photoLens);

const googlePhotoApiConcat = concat(`https://maps.googleapis.com/maps/api/place/photo?maxwidth=210&sensor=true&photoreference=`);

const apiKeyLens = lensPath(['data', 'api_key']);
const apiKeyView = RA.viewOr('', apiKeyLens);

const getgoogleApiUrl = ({ photoreference, key }) => `https://maps.googleapis.com/maps/api/place/photo?maxwidth=210&sensor=true&photoreference=${photoreference}${key}`;

export const getPhotoURL = (res) => {
  const photoreference = photoReferenceView(res);
  const key = apiKeyView(res);

  console.log({ photoreference, key });

  return getgoogleApiUrl({ photoreference, key })
}

const getCity = pipe(
  propOr([], 'address_components'),
  filterLocality,
  head,
  longNameProp
);

export const hotelResultMapper = hotel => {
  return {
    address1: hotel.formatted_address,
    city: getCity(hotel),
    phone: hotel.formatted_phone_number,
    url: hotel.website,
    google_places_id: hotel.place_id,
  }
}



export const getHotelFromRes = pipe(
  resultView,
  hotelResultMapper
);

const localDetailsDefaultFormKeys = (totalForm) => Object.keys(totalForm)
  .filter(key => !(/^[0-9]+$/.test(key)));

const localDetailsCustomFormKeys = (totalForm) => Object.keys(totalForm)
  .filter(key => (/^[0-9]+$/.test(key)));

export const pickLocalformDefault = obj =>
  pick(localDetailsDefaultFormKeys(obj))(obj);

export const pickLocalformCustom = obj =>
  pick(localDetailsCustomFormKeys(obj))(obj);


export const validateFormData = data => Object.values(data).filter(e => Boolean(e)).length > 0;




// const mapCustomField = e => ({
// 	text: e.field_label,
// 	value: e.custom_field_id
// });

const mapCustomField = (prop = 'custom_field_id') => pipe(
  pick([
    'field_label',
    prop
  ]),
  customFieldKeyMapper(prop)
);

// Rename picked object properties
const customFieldKeyMapper = (prop) => RA.renameKeys({
  field_label: 'text',
  [prop]: 'value'
});

const fromLocalDetailsElements = e => ({
  text: capitalizeFirst(e),
  value: e
});

// this.forms = [
//   ...res.data.local_details_elements.split(',').map(fromLocalDetailsElements),
//   ...res.data.local_details_custom.map(mapCustomField)
// ];

const getLDE = propOr('', 'local_details_elements');
const getLDC = propOr([], 'local_details_custom');


// For Local Details Creation the 'custom_field' is needed.
// For Local Details Edit 'custom_data_field' is needed

export const getFormsArray = (data, customKeyProp = 'custom_field_id') => [
  ...getDefaultForms(data),
  ...getCustomForms(customKeyProp)(data)
];

export const getDefaultForms = pipe(
  getLDE,
  split(','),
  filter(e => e),
  map(fromLocalDetailsElements)
);

export const getCustomForms = (keyProp = 'custom_field_id') => pipe(
  getLDC,
  map(mapCustomField(keyProp))
);

export const localDetailsCustomData = localDetailsCustom =>
  localDetailsCustom.reduce((accm, cur) => {
    accm[cur.custom_data_id] = cur.data;
    return accm;
  }, {});

export const getFormKeys = map(prop('value'));

export const pickFormFromData = (keys, data) => pick(keys, data);
export const sortLocalDetailsFields = (fileds = []) => {
  const defaultFields = ['name', 'address', 'city', 'postalcode', 'country', 'phone', 'mobile', 'email', 'url', 'notes', 'start_time', 'end_time'];

  return fileds.sort((a, b) => {
    const aIndex = findIndexByStartsWith(defaultFields, a);
    const bIndex = findIndexByStartsWith(defaultFields, b);
    if (aIndex < 0) return 1;
    if (bIndex < 0) return -1;
    return aIndex - bIndex;
  });
}

function findIndexByStartsWith(arr, field) {
  return arr.findIndex(e => {
    return field.startsWith(e);
  });
};